<div class="wrapper" [formGroup]="formGroup">
	<h2 *ngIf="entity?.id">{{ 'EDIT_' + label | translate }} </h2>
	<h2 *ngIf="!entity?.id">{{ 'CREATE_NEW_' + label | translate }} </h2>
	<div class="status">
		<bb-status *ngIf="entity" formControlName="status" [labelOn]="'ACTIVE' | translate" [labelOff]="'INACTIVE' | translate" [valueOn]="'published'" [valueOff]="'draft'"></bb-status>
	</div>
	<bb-form-element [control]="formGroup.get('title')" [label]="'TITLE' | translate">
		<bb-text required formControlName="title"></bb-text>
	</bb-form-element>

	<bb-form-element [control]="formGroup.get('code')" [label]="'CODE' | translate">
		<bb-text [disabled]="!!entity?.id" formControlName="code"></bb-text>
	</bb-form-element>

	<bb-form-element [control]="formGroup.get('playout-commercialBehaviour')" [label]="'PLAYOUT_COMMERCIAL_BEHAVIOUR' | translate">
		<bb-select [preset]="'commercialBehaviour'" formControlName="playout-commercialBehaviour">
		</bb-select>
	</bb-form-element>

	<bb-form-element *ngIf="entity?.positionType === 'preroll'" [control]="formGroup.get('playout-minClipDurationPreroll')" [label]="'PLAYOUT_MINIMUM_CLIP_DURATION_FOR_PREROLL' | translate">
		<input type="number" formControlName="playout-minClipDurationPreroll" placeholder="{{ 'LEAVE_BLANK_TO_DISABLE' | translate }}">
	</bb-form-element>

	<bb-form-element *ngIf="entity?.positionType === 'postroll'" [control]="formGroup.get('playout-minClipDurationPostroll')" [label]="'PLAYOUT_MINIMUM_CLIP_DURATION_FOR_POSTROLL' | translate">
		<input type="number" formControlName="playout-minClipDurationPostroll" placeholder="{{ 'LEAVE_BLANK_TO_DISABLE' | translate }}">
	</bb-form-element>

	<bb-form-element *ngIf="entity?.positionType !== 'overlay' && entity?.positionType !== 'vmap'" [form]="form" [label]="'ALLOW_SKIPPING' | translate">
		<bb-check [(ngModel)]="allowSkipping" (ngModelChange)="updateSkipOffset($event)" [ngModelOptions]="{standalone: true}"></bb-check>
	</bb-form-element>
	
	<div [hidden]="!allowSkipping">
		<bb-form-element [form]="form" [label]="'SKIP_COUNTDOWN_TEXT' | translate">
			<div class="input">
				<input class="skip-counter-text" type="text" formControlName="playout-skipCounterText" />
				<input class="skip-counter-offset" type="number" formControlName="playout-skipOffset" /> {{ 'SECONDS' | translate | lowercase }}.
			</div>
		</bb-form-element>

		<bb-form-element [form]="form" [label]="'SKIP_BUTTON_TEXT' | translate">
			<input type="text" formControlName="playout-skipButtonText" />
		</bb-form-element>
	</div>

	<bb-form-element *ngIf="entity?.positionType === 'preroll'" [form]="form" [control]="formGroup.get('playout-upcomingVideo')" [label]="'UPCOMING_VIDEO' | translate">
		<bb-check [(ngModel)]="entity.playout.upcomingVideo" formControlName="playout-upcomingVideo" trueValue="true" falseValue="false"></bb-check>
		<div *ngIf="entity?.playout?.upcomingVideo === 'true' && allowSkipping">
			<small>{{ 'HELP.UPCOMING_VIDEO_INFO' | translate }}</small>
		</div>
	</bb-form-element>

	<bb-form-element *ngIf="entity?.playout?.upcomingVideo === 'true' && !allowSkipping" [form]="form" [control]="formGroup.get('playout-upcomingText')" [label]="'UPCOMING_TEXT' | translate">
		<bb-text [(ngModel)]="entity.playout.upcomingText" formControlName="playout-upcomingText"></bb-text>
	</bb-form-element>

</div>
<div class="actions" *ngIf="entity">
	<button *ngIf="!unlink" class="button" (click)="delete()" [hidden]="!entity?.id"><i class="fa fa-trash"></i> {{ 'DELETE' | translate }}</button>
	<button *ngIf="unlink" class="button" (click)="delete()" [hidden]="!entity?.id"><i class="fa fa-unlink"></i> {{ 'UNLINK' | translate }}</button>
	<button *ngIf="entity?.id" class="button submit" (click)="saveQuickEdit()"><i class="fa fa-floppy-o"></i> {{ 'SAVE' || translate }}</button>
	<button class="button cancel" (click)="onCancelClick()"><i class="fa fa-ban"></i> {{ 'CANCEL' | translate }}</button>
</div>
